import { storage } from "@/components/Storage";
import { flightSchedule } from "../Pages/FlightSchedulePage";

var ModalTelegram = {
	view: function (ctrl, args) {
		let allTGOReady;
		const CardSignature = storage.config.CardSignature;
		const DenyCloseWorks = storage.config.DenyCloseWorks;

		if (
			flightSchedule.currentList.filter(
				(x) =>
					(x.factBeginTime == null || x.factFinishTime == null) &&
					!x.isCancelled,
			).length === 0
		) {
			allTGOReady = true;
		} else {
			allTGOReady = false;
		}

		let modalWarningShow;

		if (!DenyCloseWorks && CardSignature) {
			modalWarningShow = false;
		} else {
			modalWarningShow = !allTGOReady;
		}

		return m(
			".popup",
			m(".popup-content", [
				m(".telegram-modal-header.bg-primary", [
					m("span", "Телеграмма"),
					m("span.ml-auto", { onclick: ModalContainerTelegram.close }, [
						m("i.glyphicon.glyphicon-remove"),
						m.trust("&nbsp;Закрыть"),
					]),
				]),
				m(
					".telegram-modal-body",
					args.data.split("\r\n").map(function (field) {
						return [m("p[style='margin: 0; padding: 5px 0;']", field)];
					}),
				),
				m(".telegram-modal-button", [
					m(
						"button.btn.btn-success.btn-md[style='width: 100%;']",
						{
							onclick: ModalContainerTelegram.close,
						},
						"ОК",
					),
				]),
			]),
		);
	},
};

export var ModalContainerTelegram = {
	container: null,
	open: function (ctrl) {
		ModalContainerTelegram.container =
			document.querySelector("#modal-container");
		if (!ModalContainerTelegram.container) {
			ModalContainerTelegram.container = document.createElement("div");
			ModalContainerTelegram.container.id = "modal-container";
			document.body.appendChild(ModalContainerTelegram.container);
            document.body.style.overflow = 'hidden';

			m.mount(
				ModalContainerTelegram.container,
				m.component(ModalTelegram, { data: ctrl }),
			);
		}
	},
	close: function () {
		m.mount(ModalContainerTelegram.container, null);
		document.body.removeChild(ModalContainerTelegram.container);
		ModalContainerTelegram.container = null;
        document.body.style.overflow = 'auto';
	},
};
